import { isEmpty } from '@widergy/web-utils/lib/array';
import { objectIsEmpty } from '@widergy/web-utils/lib/object';
import { onlyNumbers } from '@widergy/web-utils/lib/normalize';
import moment from 'moment';
import { createSelector } from 'reselect';
import { getIn } from 'seamless-immutable';

import { message } from 'utils/stringUtils';

const formatedTurns = turn => {
  if (objectIsEmpty(turn.working_day_slot)) return {};
  const date = moment(turn.date, 'YYYY-MM-DD');
  const timeFormated = `${turn.working_day_slot.begins_at} - ${turn.working_day_slot.ends_at}`;
  const dateFormated = `${date.format('dddd')} ${date.format('DD')} ${message('Commons:of')} ${date.format(
    'MMMM'
  )} `;

  return {
    id: turn.id,
    procedureName: turn.procedure_name || '',
    location: turn.office_city || '',
    address: turn.office_address || '',
    date: dateFormated || '',
    time: timeFormated || ''
  };
};

export const userTurnsSelector = turns => {
  if (isEmpty(turns)) return [];
  return turns.map(formatedTurns);
};

export const primaryPhoneSelector = createSelector(
  store => getIn(store.auth, ['currentUser', 'additional_information', 'phones'], []),
  store => getIn(store.auth, ['currentUser', 'additional_information', 'mobiles'], []),
  (phones, mobiles) => {
    const phoneNumbers = [...mobiles, ...phones];
    const phoneDefault = phoneNumbers.find(item => item.default);
    if (phoneDefault) return phoneDefault && onlyNumbers(phoneDefault.number);
    return !isEmpty(phoneNumbers) && onlyNumbers(phoneNumbers[0].number);
  }
);
